module.exports = __webpack_public_path__ + "static/media/red.b474b382.png";